import React from 'react';
import { observer } from 'mobx-react-lite';
import { useSelectedResultInfoStore, useTranslation } from '@pascal/pascal-core';
import { Results } from '@pascal/pascal-core/table-line/table-components/results';
import ResultRow from '../resultRow';

const AdditionalResultWr = observer(() => {
  const { setSelectedResultInfo } = useSelectedResultInfoStore();
  const t = useTranslation();

  return (
    <Results
      collRenderer={(result) => (
        <ResultRow
          key={result.hash}
          result={result}
          setSelectedResultInfo={setSelectedResultInfo}
          t={t}
        />
      )}
      isShowAdditionalResults
    />
  );
});

export default AdditionalResultWr;
